(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cartify-universe"]) return;
  try {
    
  function initUniverses(root=document) {
    root.querySelectorAll('[data-universe]').forEach(scene=>{
      if(scene.dataset.ready) return;
      scene.dataset.ready='true';
      const mascot=scene.querySelector('.universe__mascot');
      if(!mascot) return;
      mascot.addEventListener('click',()=>{
        mascot.classList.toggle('is-happy');
        scene.querySelector('.universe__speech').textContent=mascot.dataset.greeting;
      });
      if(!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        scene.addEventListener('pointermove',event=>{
          if(event.pointerType==='touch') return;
          const r=mascot.getBoundingClientRect();
          const x=Math.max(-5,Math.min(5,(event.clientX-r.left-r.width/2)/35));
          const y=Math.max(-5,Math.min(5,(event.clientY-r.top-r.height/2)/35));
          mascot.querySelectorAll('i').forEach(eye=>eye.style.translate=x+'px '+y+'px');
        });
      }
    });
  }
  initUniverses();
  document.addEventListener('shopify:section:load',event=>initUniverses(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cartify-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const worlds = document.querySelectorAll('[data-cartify-world]');
    worlds.forEach((world) => {
      if (world.dataset.ready) return;
      world.dataset.ready = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const glow = world.querySelector('[data-cw-glow]');
      const depthItems = world.querySelectorAll('[data-cw-depth]');
      const eyes = world.querySelectorAll('[data-cw-eye]');
      const stage = world.querySelector('[data-cw-stage]');

      if (!reduced && stage) {
        stage.addEventListener('pointermove', (event) => {
          const rect = stage.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - .5;
          const y = (event.clientY - rect.top) / rect.height - .5;
          depthItems.forEach((item) => {
            const depth = Number(item.dataset.cwDepth || 10);
            item.style.translate = `${x * depth}px ${y * depth}px`;
          });
          eyes.forEach((eye) => {
            eye.style.transform = `translate(${x * 7}px, ${y * 7}px)`;
          });
          if (glow) {
            glow.style.left = `${event.clientX - world.getBoundingClientRect().left}px`;
            glow.style.top = `${event.clientY - world.getBoundingClientRect().top}px`;
          }
        });
      }

      world.querySelectorAll('[data-cw-no]').forEach((button) => {
        button.addEventListener('click', () => {
          const character = button.closest('[data-cw-character]');
          const message = character && character.querySelector('[data-cw-message]');
          if (!message) return;
          const options = ['No pressure. I will float right here.', 'Okay... but I found something very cool.', 'I knew you were curious. Take another look!'];
          message.textContent = options[Math.floor(Math.random() * options.length)];
          character.classList.add('is-reacting');
          window.setTimeout(() => character.classList.remove('is-reacting'), 700);
        });
      });

      if (!reduced) {
        world.querySelectorAll('[data-cw-tilt]').forEach((card) => {
          card.addEventListener('pointermove', (event) => {
            const rect = card.getBoundingClientRect();
            const rx = ((event.clientY - rect.top) / rect.height - .5) * -8;
            const ry = ((event.clientX - rect.left) / rect.width - .5) * 8;
            card.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) translateY(-5px)`;
          });
          card.addEventListener('pointerleave', () => { card.style.transform = ''; });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
